import{createStorageHook as o}from"./storage";const{Storage:e,StorageContext:t,useStorage:r,withStorage:s}=o("sessionStorage");var n=e;export{e as SessionStorage,t as SessionStorageContext,n as default,r as useSessionStorage,s as withSessionStorage};
//# sourceMappingURL=use-session-storage.js.map
